export default {
  name: 'Lobby',
  id: 'Lobby',
  data: [
    {
      title: 'Many customers and employees are in the lobby.',
      icon1: '/static/svgs/commercial/lobby.svg',
      answers: [
        'Employee safety should always be your first priority. Account for all employees by establishing evacuation plans in advance, identifying areas outside the building that are designated meeting places.'
      ],
      correctAnswerIndex: 0,
      position: {
        x: -0.8,
        y: -0.2,
        z: 1.35
      },
      completed: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/commercial/firstFloor/Lobby.js